import { provide, inject, computed, reactive } from "vue-demi";
import { MAX_COLS, MAX_ROWS } from "./constants.mjs";
const gridInjectionKey = "grid";
const getColspan = (item) => {
  const formatWidth = Number(item.width);
  const width = formatWidth < MAX_COLS ? formatWidth : MAX_COLS;
  return {
    gridColumn: `span ${width} / span ${width}`
  };
};
const getRowspan = (item) => {
  const formatHeight = Number(item.height);
  const height = formatHeight < MAX_ROWS ? formatHeight : MAX_ROWS;
  return { gridRow: `span ${height} / span ${height}` };
};
const useGrid = () => {
  const grid = reactive({ items: [] });
  provide(gridInjectionKey, grid);
};
const useGridItem = (gridItem) => {
  const grid = inject(gridInjectionKey);
  grid.items.push(gridItem);
  const gridItemStyles = computed(() => ({
    ...getColspan(gridItem),
    ...getRowspan(gridItem)
  }));
  return { gridItemStyles };
};
export { useGrid, useGridItem };
